export enum MimeTypesEnum {
  UNKNOWN = 'UNKNOWN',
  PDF = 'PDF',
  TXT = 'TXT',
  PPT = 'PPT',
  JPG = 'JPG',
  JPEG = 'JPEG',
  GIF = 'GIF',
  WEBP = 'WEBP',
}
